// 10% of basic salary is deducted as employee PF contribution
// and same amount is contributed by employer
export const ProvidentFundContribution = {
  employee: 10,
  employer: 10
};

// 11% of basic salary is deducted as employee SSF contribution
// and 20% of basic salary is contributed by employer
export const SocialSecurityFundContribution = {
  employee: 11,
  employer: 20
};

/**
 * Tax Slab:
 * @info if enrolled in ssf the first 1% don't have to be paid
 */

// define shape of a slab entry
type Slab = {
  value: number;
  rate: number;
};

// define shape of tax slabs for one status
type TaxSlabs = {
  1: Slab;
  2: Slab;
  3: Slab;
  4: Slab;
  5: Slab;
  6: Slab;
};

// define shape for all statuses
type IncomeTaxSlabType = {
  single: TaxSlabs;
  couple: TaxSlabs;
};

// now the constant with full typing
export const IncomeTaxSlab: IncomeTaxSlabType = {
  single: {
    1: { value: 5_00_000, rate: 1 },
    2: { value: 2_00_000, rate: 10 },
    3: { value: 3_00_000, rate: 20 },
    4: { value: 10_00_000, rate: 30 },
    5: { value: 30_00_000, rate: 36 },
    6: { value: 50_00_000, rate: 39 }
  },
  couple: {
    1: { value: 6_00_000, rate: 1 },
    2: { value: 2_00_000, rate: 10 },
    3: { value: 3_00_000, rate: 20 },
    4: { value: 10_00_0000, rate: 30 },
    5: { value: 30_00_000, rate: 36 },
    6: { value: 50_00_000, rate: 40 }
  }
};

// Fields
export const MonthlyAllowanceComponents = {
  BASIC_SALARY: "basicSalary",
  HOUSE_RENT_ALLOWANCE: "houseRentAllowance",
  CONVEYANCE_ALLOWANCE: "conveyanceAllowance",
  DEARNESS_ALLOWANCE: "dearnessAllowance",
  MEDICAL_ALLOWANCE: "medicalAllowance",
  OTHER_ALLOWANCE: "otherAllowance"
} as const;

export const YearlyEarningsComponents = {
  FESTIVAL_ALLOWANCE: "festivalAllowance"
} as const;

export const BonusComponents = {
  SIGNING_BONUS: "signingBonus",
  RETENTION_BONUS: "retentionBonus",
  REFERRAL_BONUS: "referralBonus",
  FESTIVAL_BONUS: "festivalBonus",
  PERFORMANCE_BONUS: "performanceBonus",
  OTHER_BONUS: "otherBonus"
} as const;

export const DeductionsComponents = {
  PROVIDENT_FUND: "providentFund",
  SOCIAL_SECURITY_FUND: "socialSecurityFund",
  CITIZEN_INVESTMENT_TRUST: "citizenInvestmentTrust",
  LIFE_INSURANCE_PREMIUM: "lifeInsurancePremium",
  ADVANCE_DEDUCTION: "advanceDeduction",
  LOAN_DEDUCTION: "loanDeduction",
  OTHER_DEDUCTIONS: "otherDeductions"
} as const;

export const AttendanceSummaryComponents = {
  PRESENT: "present",
  ABSENT: "absent"
} as const;
